import { endRoute } from '$shared/utils/routes';

export const termsRoutes = {
  terms: endRoute<{ slug: string }>('/terms/:slug'),
};
